const style = {
  container: {
    border: `1px solid #ececec`
  },
  inputWrapper: {
    padding: 0
  },
  input: {
    background: `white`,
    border: `none`,
    borderRadius: `3px`,
    borderBottom: 0,
    width: `100%`,
    padding: `5px 15px`,
    fontSize: `14px`,
    color: `#666`
  },
  selectWrapper: {
    padding: 0
  },
  select: {
    display: `block`,
    height: `100%`,
    textTransform: `uppercase`,
    background: `#eeedee`,
    fontSize: `12px`,
    border: `none`,
    appearance: `none`,
    '-moz-appearance': `none`,
    '-webkit-appearance': `none`,
    textAlign: `center`,
    textAlignLast: `center`,
    borderRadius: 0,
    padding: `0 10px`,
    color: `#777`
  },
  buttonWrapper: {
    padding: 0
  },
  button: {
    width: `100%`,
    height: `100%`,
    background: `#A94545`,
    color: `white`,
    fontWeight: 400,
    fontSize: `12px`,
    border: `none`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Support/style/search.js